import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { LoginSettingsFacade } from '@lyceo/homi/login/data-access';
import { filter, of, switchMap } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

export function loginSettingsGuard(): CanActivateFn {
  return () => {
    const loginSettingsFacade: LoginSettingsFacade =
      inject(LoginSettingsFacade);

    return toObservable(loginSettingsFacade.settingsFinished).pipe(
      filter((finished) => finished),
      switchMap(() => of(loginSettingsFacade.settingsSet())),
    );
  };
}
